export enum SourceCodeButtonItemAction {
  GenerateCode = 'generate-code',
  SaveCustomCode = 'save-custom-code',
  DownloadFile = 'download-file',
  DownloadSourceFile = 'download-source-file',
  Find = 'find',
  /* The reload process can be executed without generating code. This also creates issues; the reload action should be paused for now. */
  // Reload = 'reload'
}
